/**
 * Alerts module
 */

import React, { useRef } from 'react';

import { DEBUG_MODE, HTTP_STATUS_URL } from "../../config";

/**
 * Represents a error span
 */
export function ErrorDisplay({ error }: { error: { status; message; cause; }; }): React.JSX.Element {

    const lbShowErr = useRef<HTMLButtonElement>(null);
    const lbErrCause = useRef<HTMLDivElement>(null);

    function showCause(b: boolean) {
        const visib = ['block', 'none'];
        lbShowErr.current.style.display = visib[b ? 1 : 0];
        lbErrCause.current.style.display = visib[b ? 0 : 1];
    }

    let code: string = null;
    if (DEBUG_MODE) code = error && error.status || null;

    return (
        <div style={{ width: '100%' }}>
            {error.message}<br />
            {error.cause &&
                <button className="link" ref={lbShowErr}
                    onClick={() => showCause(true)}>Show details</button>}
            <div className="w3-display-container w3-animate-opacity"
                style={{ display: 'none', width: '100%' }} ref={lbErrCause}>
                Got error: <b>{error.cause}</b><br />
                {code &&
                    <span>
                        <a href={HTTP_STATUS_URL + code} target='_blank' rel="noreferrer">About this error</a>
                        &nbsp;-&nbsp;
                    </span>}
                <button className="link" onClick={() => showCause(false)}>Close</button>
            </div>
        </div>
    );
}
